import React from 'react'
import {Link, useParams} from 'react-router-dom'
import invert from 'invert-color'
import {isEmpty} from 'lodash'
import {formatTime, pluralise, toSentence} from 'admin/lib/format'
import useTextMessage from 'admin/hooks/useTextMessage'
import useDocument from 'admin/hooks/useDocument'
import Header from '../shared/Header'
import Modal from '../shared/Modal'
import useModal from '../../hooks/useModal'

const statusColors = {
  enroute: '#EAAC3C',
  delivered: '#6DC47C',
  expired: '#D22043',
  rejected: '#D22043',
  failed: '#D22043'
}

export const Status = ({status}) => {
  const color = statusColors[status]
  let style = {overflowWrap: 'break-word'}
  if (color) {
    style.backgroundColor = color
    style.color = invert(color, true)
  }
  return (
    <span className='tag' style={style}>
      {status || 'submitted'}
    </span>
  )
}

export default () => {
  const {organisationID} = useParams()
  const {textMessageId, popModal} = useModal()
  const {textMessage} = useTextMessage(organisationID, textMessageId)
  useDocument({title: `Text message ${textMessageId}`})

  if (isEmpty(textMessage)) return null

  const statusCounts = textMessage.recipients.reduce((counts, recipient) => {
    const status = recipient.status || 'submitted'
    if (!counts[status]) counts[status] = 0
    counts[status] += 1
    return counts
  }, {})

  const statusCountsSentence = toSentence(
    Object.entries(statusCounts).map(([status, count]) => [count, status].join(' '))
  )

  const handleClose = e => {
    e.preventDefault()
    popModal('text-message', ['textMessageId'])
  }

  return (
    <Modal onClose={handleClose} flashId='show-text-message'>
      <section className='py-3 section has-background-info'>
        <div className='container'>
          <span className='is-size-7 has-text-light'>
            Submitted by {textMessage.sender} on {formatTime(textMessage.createdAt)}
          </span>
        </div>
      </section>

      <Header title={pluralise('recipient', textMessage.recipients.length, true)} subtitle={statusCountsSentence} />

      <section className='section is-narrow'>
        <div className='container'>
          <table className='table is-striped is-fullwidth'>
            <colgroup>
              <col span='1' width='60%' />
              <col span='1' width='20%' />
              <col span='1' width='20%' />
            </colgroup>
            <thead>
              <tr>
                <th>Message</th>
                <th>Recipient</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {textMessage.recipients.map((recipient, i) => (
                <tr valign='top' key={i}>
                  <td className='has-linebreaks is-size-7' style={{marginBottom: '0', overflowWrap: 'break-word'}}>
                    {recipient.content}
                  </td>
                  <td>
                    <Link to={`/orgs/${organisationID}/accounts/${recipient.account.id}`}>
                      {recipient.account.displayName}
                    </Link>
                    {recipient.account.displayName !== recipient.account.contactFullName &&
                    !!recipient.account.contactFullName ? (
                      <sub className='has-text-weight-semibold'>{recipient.account.contactFullName}</sub>
                    ) : (
                      <br />
                    )}
                    {recipient.e164MobileNumber}
                  </td>
                  <td>
                    <Status status={recipient.status} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </Modal>
  )
}
